import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import { Edit, Delete, ThirtyFpsSelect } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowData,
  getRowOfRT,
  isValidItem,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
//import { fetchLedgerDetail } from './API'
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { fetchLedgeGroup, fetchLedgerMaster } from "./API";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import LedgerGroup from "./LedgerGroup";
import GstInfo from "./GstInfo";
import CtART from "./CustomTool/ResponsiveTable";

class LedgerMaster extends Component {
  // Delivery Responsible Person
  state = {
    LedgerEffect: [{ Type: "Cr-Cr & Dr-Dr" }, { Type: "Cr-Dr & Dr-Cr" }],
    GroupName: [],
    StateList: [],
    GroupHeader: [
      { GroupHeader: "Trading" },
      { GroupHeader: "Profit-Loss" },
      { GroupHeader: "Assets" },
      { GroupHeader: "Liability" },
      { GroupHeader: "None" },
    ],
    GstRegistrationType: [
      // { Type: " " },
      { Type: "Regular" },
      { Type: "Consumer" },
      { Type: "Unregistered" },
      { Type: "Composition" },
    ],
    GstRate: [],
    HSNCode: [],
    EligibleITC: [
      { ITC: "ITC Available Import of goods" },
      { ITC: "ITC Available Import of services" },
      { ITC: "ITC Available Inward supplies liable to reverse charge" },
      { ITC: "ITC Available Inward supplies from ISD" },
      { ITC: "ITC Available All other ITC" },
      { ITC: "ITC Reversed As per Rule 42 & 43 of SGST/CGST rules" },
      { ITC: "ITC Reversed Others" },
      { ITC: "Ineligible ITC As per section 17(5) of CGST//SGST Act" },
      { ITC: "Ineligible ITC Others" },
    ],
    CityList: [],
    AreaList: [],
    OpeningType: [{ Type: "CR" }, { Type: "DR" }],
    BackgroundProcess: [
      // { Process: " " },
      // { Process: "Cash" },
      // { Process: "Cheque" },
      // { Process: "Bank" },
      // { Process: "CGST" },
      // { Process: "SGST" },
      // { Process: "IGST" },
      // { Process: "Reverse Charge CGST" },
      // { Process: "Reverse Charge SGST" },
      // { Process: "Reverse Charge IGST" },
      // { Process: "Customer" },
      // { Process: "Supplier" },
      // { Process: "Sales" },
      // { Process: "Purchase" },
      // { Process: "TDS" },
    ],
    UserNameList: [],
    TransactionType: [
      { Type: "Normal" },
      { Type: "Default" },
      { Type: "Reverse" },
    ],
    removeKeyboardShortCuts: null,
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "bint_ledgeridsrno", label: "SR NO", hide: true },
      { id: "vac_gstno", label: "GSTIN NO" },
      { id: "vac_ledgername", label: "Legder Name" },
      { id: "bint_ledgercode", label: "L.C." },
      { id: "vac_firmname", label: "Firm Name", hide: true },
      { id: "vac_groupname", label: "Group Name" },
      { id: "vac_groupheader", label: "Group Header" },
      { id: "vac_registrationtype", label: "Gst Regtration Type", hide: true },
      { id: "vac_eligibleitc", label: "Eligilble ITC", hide: true },
      { id: "vac_address", label: "Address", hide: true },
      { id: "vac_city", label: "City", hide: true },
      { id: "vac_area", label: "Area", hide: true },
      { id: "vac_state", label: "State", hide: true },
      { id: "vac_statecode", label: "State Code", hide: true },
      { id: "vac_pan", label: "PAN No", hide: true },
      { id: "vac_adharno", label: "Aadhar No", hide: true },
      { id: "dec_opbalance", label: "Opening Amount" },
      { id: "vac_optype", label: "Opening Type" },
      { id: "vac_mobileno1", label: "Mobile1", hide: true },
      { id: "vac_mobileno2", label: "Mobile2", hide: true },
      { id: "vac_email1", label: "Email1", hide: true },
      { id: "vac_email2", label: "Email2", hide: true },
      { id: "vac_backgroundprocess", label: "Background Process" },
      { id: "vac_ledgereffect", label: "Ledger Effect" },
      { id: "vac_remark", label: "Remark" },
      { id: "int_autoledger", label: "int_autoledger", hide: true },
      { id: "dec_opbalancecrdr", label: "Opening Amount", hide: false },
    ],
    columnsdata: [
      { accessorKey: "bint_ledgeridsrno", header: "SR NO" },
      { accessorKey: "vac_gstno", header: "GSTIN NO" },
      { accessorKey: "vac_ledgername", header: "Legder Name" },
      {
        accessorKey: "bint_ledgercode",
        header: "L.C.",
        enableColumnActions: false,
        enableSorting: false,
        size: 70,
      },
      { accessorKey: "vac_firmname", header: "Firm Name" },
      { accessorKey: "vac_groupname", header: "Group Name" },
      { accessorKey: "vac_groupheader", header: "Group Header" },
      {
        accessorKey: "vac_registrationtype",
        header: "Gst Regtration Type",
      },
      // { accessorKey: "vac_profitloss", header: "Gst Rate", hide: "true" },
      // { accessorKey: "vac_profitloss", header: "HSN Code", hide: "true" },
      // { accessorKey: "vac_profitloss", header: "Unit", hide: "true" },
      { accessorKey: "vac_eligibleitc", header: "Eligilble ITC" },
      { accessorKey: "vac_address", header: "Address" },
      { accessorKey: "vac_city", header: "City" },
      { accessorKey: "vac_area", header: "Area" },
      { accessorKey: "vac_state", header: "State" },
      { accessorKey: "vac_statecode", header: "State Code" },
      { accessorKey: "vac_pan", header: "PAN No" },
      { accessorKey: "vac_adharno", header: "Aadhar No" },
      {
        accessorKey: "dec_opbalancecrdr",
        header: "Opening Amount",
        enableColumnActions: false,
      },
      {
        accessorKey: "dec_opbalance",
        header: "Opening Amount",
        enableColumnActions: false,
      },
      { accessorKey: "vac_optype", header: "Opening Type" },
      { accessorKey: "vac_mobileno1", header: "Mobile1" },
      { accessorKey: "vac_mobileno2", header: "Mobile2" },
      { accessorKey: "vac_email1", header: "Email1" },
      { accessorKey: "vac_email2", header: "Email2" },
      {
        accessorKey: "vac_backgroundprocess",
        header: "Background Process",
        enableColumnActions: false,
        enableColumnDragging: false,
      },
      // { accessorKey: "vac_username", header: "User Name" },
      { accessorKey: "vac_ledgereffect", header: "Ledger Effect" },
      { accessorKey: "vac_remark", header: "Remark" },
      { accessorKey: "int_autoledger", header: "int_autoledger" },
    ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "LedgerMaster:",
        actionType: "AlertResponsive",
        visiblecondition: [
          { colID: "DisableEdit", value: false, relationalOperator: "==" },
        ],
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "LedgerMaster:",
        // actionType: "Conditional",
        // actionType: "AlertResponsive",
        // visiblecondition: [
        visiblecondition: [
          { colID: "DisableDelete", value: false, relationalOperator: "==" },
        ],
      },
    ],
    keyColumn: [
      "bint_ledgeridsrno", //0
      "bint_acid", //1
      "vac_company", //2
      "vac_gstno", //3
      "vac_ledgername", //4
      "bint_ledgercode", //5
      "vac_firmname", //6
      "vac_groupname", //7
      "vac_groupheader", //8
      "vac_registrationtype", //9
      "vac_eligibleitc", //10
      "vac_address", //11
      "vac_city", //12
      "vac_area", //13
      "vac_state", //14
      "vac_statecode", //15
      "vac_pan", //16
      "vac_adharno", //17
      "dec_opbalancecrdr", //18
      "vac_optype", //19
      "vac_mobileno1", //20
      "vac_mobileno2", //21
      "vac_email1", //22
      "vac_email2", //23
      "dec_opbalance", //24
      "vac_backgroundprocess", //25
      "vac_username",
      "vac_ledgereffect", //26
      "int_autoledger", //27
      "vac_remark", //28
    ],
    maxLegderCode: "",
    formData: {
      EditlLedgerIdSrNo: "",
      bint_srno: "",
      txtCompany: "",
      txtGSTINNO: "",
      txtLegderName: "",
      txtLegderCode: "",
      txtFirmName: "",
      cmbGroupName: "",
      cmbGroupHeader: "",
      cmbGstRegtrationType: "",
      txtEligilbleITC: "",
      txtAddress: "",
      cmbCity: "",
      cmbArea: "",
      cmbState: "Gujarat",
      txtStateCode: "24",
      txtPANNo: "",
      txtAadharNo: "",
      txtOpeningAmt: "",
      cmbOpeningType: "CR",
      txtMobileno1: "",
      txtMobileno2: "",
      txtEmail1: "",
      txtEmail2: "",
      cmbHSNCode: "",
      txtUnit: "",
      cmbBackgroundProcess: " ",
      cmbusername: "",
      cmbLedgerEffect: "Cr-Cr & Dr-Dr",
      txtRemark: "",
    },
    searchData: {
      vac_gstno: "",
      vac_ledgername: "",
      bint_ledgercode: "",
      vac_firmname: "",
      vac_groupname: "",
      vac_groupheader: "",
      vac_registrationtype: "",
      vac_address: "",
      vac_city: "",
      vac_area: "",
      vac_state: "",
      vac_statecode: "",
      vac_pan: "",
      vac_adharno: "",
      dec_opbalance: "",
      vac_optype: "",
      vac_mobileno1: "",
      vac_mobileno2: "",
      vac_email1: "",
      vac_email2: "",
      vac_backgroundprocess: "",
      vac_ledgereffect: "",
      vac_remark: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,

    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,

    DisableDelete: false,
    DisableEdit: false,
    DisableBGProcess: false,
    VisibleDeliveryPerson: false,
  };

  //#region Component
  componentDidMount() {
    {
      !this.props.showHeading && (document.title = "RA : Ledger");
    }
    this.props.setActiveMenu("LedgerMaster");
    this.ShortCut();
    this.setSearchColumns();
    this.props.verifyUserID(
      this.getInfo,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
    // this.getInfo();
  }
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    let changeLedger = false;
    if (
      e.target.name === "cmbusername" &&
      e.target.value !== "" &&
      (this.state.formData.txtLegderName === "" ||
        this.state.formData.txtLegderName === this.state.formData.cmbusername)
    ) {
      changeLedger = true;
    }
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        console.log("Regestortype", this.state.formData.cmbGstRegtrationType);

        if (e.target.name === "txtGSTINNO") {
          let Gstno = this.state.formData.txtGSTINNO.substring(2, 12);
          this.setState({
            formData: { ...this.state.formData, txtPANNo: Gstno },
          });
        } else if (e.target.name === "cmbState") {
          let txtStateCode = this.state.formData.txtStateCode;
          this.state.StateList.map((curState) => {
            if (e.target.value === curState.vac_state) {
              txtStateCode = curState.vac_statecode;
            }
          });
          this.setState({
            formData: { ...this.state.formData, txtStateCode },
          });
        } else if (e.target.name === "cmbGroupName") {
          let cmbGroupHeader = this.state.formData.cmbGroupHeader;
          this.state.GroupName.map((curGroupName) => {
            if (e.target.value === curGroupName.vac_groupname) {
              cmbGroupHeader = curGroupName.vac_groupheader;
            }
          });
          this.setState({
            formData: { ...this.state.formData, cmbGroupHeader },
          });
        } else if (e.target.name === "cmbBackgroundProcess") {
          if (e.target.value === "Delivery Responsible Person") {
            this.setState({ VisibleDeliveryPerson: true });
          } else {
            this.setState({ VisibleDeliveryPerson: false });
          }
        } else if (e.target.name === "cmbusername") {
          // console.log("e.target.value", e.target.value)
          // console.log("this.state.formData.txtLegderName", this.state.formData.txtLegderName)
          // console.log("this.state.formData.cmbusername", this.state.formData.cmbusername)
          // console.log('e.target.value !== ""', e.target.value !== "")
          // console.log('this.state.formData.txtLegderName === ""', this.state.formData.txtLegderName === "")
          // console.log('this.state.formData.txtLegderName === this.state.formData.cmbusername', this.state.formData.txtLegderName === this.state.formData.cmbusername)
          if (changeLedger) {
            this.setState({
              formData: {
                ...this.state.formData,
                txtLegderName: e.target.value,
              },
            });
          }
        }
      }
    );
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "Lbl",
        id: "bint_ledgeridsrno",
      },
      {
        cType: "CtTxt",
        id: "vac_gstno",
        label: "GST NO",
        value: this.state.searchData.vac_gstno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "130",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_ledgername",
        label: "Ledger Name",
        value: this.state.searchData.vac_ledgername,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "bint_ledgercode",
        label: "Ledger Code",
        value: this.state.searchData.bint_ledgercode,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_firmname",
        label: "FirmName",
        value: this.state.searchData.vac_firmname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_groupname",
        items: this.state.GroupName,
        label: "Group Name",
        value: this.state.searchData.vac_groupname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "130",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_groupheader",
        items: this.state.GroupHeader,
        label: "Group Header",
        value: this.state.searchData.vac_groupheader,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_registrationtype",
        items: this.state.GstRegistrationType,
        label: "Gst Regtration Type",
        value: this.state.searchData.vac_registrationtype,
        handleOnChange: this.handleOnSearchInputChange,
        width: "170",
        maxLength: "100",
        // colID: 'status',
      },
      { cType: "Lbl", id: "vac_eligibleitc" },
      {
        cType: "CtTxt",
        id: "vac_address",
        label: "Address",
        value: this.state.searchData.vac_address,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_city",
        items: this.state.City,
        label: "City",
        value: this.state.searchData.vac_city,
        handleOnChange: this.handleOnSearchInputChange,
        width: "130",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_area",
        items: this.state.Area,
        label: "Area",
        value: this.state.searchData.vac_area,
        handleOnChange: this.handleOnSearchInputChange,
        width: "130",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_state",
        items: this.state.StateList,
        label: "State",
        value: this.state.searchData.vac_state,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_statecode",
        label: "State Code",
        value: this.state.searchData.vac_statecode,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_pan",
        label: "PAN No",
        value: this.state.searchData.vac_pan,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_adharno",
        label: "Adhar No",
        value: this.state.searchData.vac_adharno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_opbalancecrdr",
        label: "Opening Amount",
        value: this.state.searchData.dec_opbalance,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "vac_optype",
        items: this.state.OpeningType,
        label: "Opening Type",
        value: this.state.searchData.vac_optype,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_mobileno1",
        label: "Mobile 1",
        value: this.state.searchData.vac_mobileno1,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_mobileno2",
        label: "Mobile 2",
        value: this.state.searchData.vac_mobileno2,
        handleOnChange: this.handleOnSearchInputChange,
        width: "100",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_email1",
        label: "Email 1",
        value: this.state.searchData.vac_email1,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_email2",
        label: "Email 2",
        value: this.state.searchData.vac_email2,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_backgroundprocess",
        items: this.state.BackgroundProcess,
        label: "Background Process",
        value: this.state.searchData.vac_backgroundprocess,
        handleOnChange: this.handleOnSearchInputChange,
        width: "190",
        maxLength: "100",
        // colID: 'status',
      },
      // {
      //   cType: "CtTxt",
      //   id: "vac_username",
      //   items: this.state.UserNameList,
      //   label: "User Name",
      //   value: this.state.searchData.vac_username,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "190",
      //   maxLength: "100",
      //   // colID: 'status',
      // },
      {
        cType: "CtTxt",
        id: "vac_ledgereffect",
        items: this.state.LedgerEffect,
        label: "Ledger Effect",
        value: this.state.searchData.vac_ledgereffect,
        handleOnChange: this.handleOnSearchInputChange,
        width: "170",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
        // colID: 'status',
      }
    );
    this.setState({ searchColumns });
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.sફearchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_gstno.length === 0 ||
            (row["vac_gstno"] &&
              row["vac_gstno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_gstno.toLowerCase()))) &&
          (this.state.searchData.vac_ledgername.length === 0 ||
            (row["vac_ledgername"] &&
              row["vac_ledgername"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_ledgername.toLowerCase()
                ))) &&
          (this.state.searchData.bint_ledgercode.length === 0 ||
            (row["bint_ledgercode"] &&
              row["bint_ledgercode"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.bint_ledgercode.toLowerCase()
                ))) &&
          (this.state.searchData.vac_firmname.length === 0 ||
            (row["vac_firmname"] &&
              row["vac_firmname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_firmname.toLowerCase()))) &&
          (this.state.searchData.vac_groupname === "" ||
            (row["vac_groupname"] &&
              row["vac_groupname"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_groupname.toLowerCase()
                ))) &&
          (this.state.searchData.vac_groupheader === "" ||
            (row["vac_groupheader"] &&
              row["vac_groupheader"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_groupheader.toLowerCase()
                ))) &&
          (this.state.searchData.vac_registrationtype === "" ||
            (row["vac_registrationtype"] &&
              row["vac_registrationtype"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_registrationtype.toLowerCase()
                ))) &&
          (this.state.searchData.vac_address.length === 0 ||
            (row["vac_address"] &&
              row["vac_address"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_address.toLowerCase()))) &&
          (this.state.searchData.vac_city === "" ||
            (row["vac_city"] &&
              row["vac_city"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_city.toLowerCase()))) &&
          (this.state.searchData.vac_area === "" ||
            (row["vac_area"] &&
              row["vac_area"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_area.toLowerCase()))) &&
          (this.state.searchData.vac_state === "" ||
            (row["vac_state"] &&
              row["vac_state"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_state.toLowerCase()))) &&
          (this.state.searchData.vac_statecode.length === 0 ||
            (row["vac_statecode"] &&
              row["vac_statecode"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_statecode.toLowerCase()
                ))) &&
          (this.state.searchData.vac_pan.length === 0 ||
            (row["vac_pan"] &&
              row["vac_pan"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_pan.toLowerCase()))) &&
          (this.state.searchData.vac_adharno.length === 0 ||
            (row["vac_adharno"] &&
              row["vac_adharno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_adharno.toLowerCase()))) &&
          (this.state.searchData.dec_opbalance.length === 0 ||
            (row["dec_opbalance"] &&
              row["dec_opbalance"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dec_opbalance.toLowerCase()
                ))) &&
          (this.state.searchData.vac_optype === "" ||
            (row["vac_optype"] &&
              row["vac_optype"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_optype.toLowerCase()))) &&
          (this.state.searchData.vac_mobileno1.length === 0 ||
            (row["vac_mobileno1"] &&
              row["vac_mobileno1"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_mobileno1.toLowerCase()
                ))) &&
          (this.state.searchData.vac_mobileno2.length === 0 ||
            (row["vac_mobileno2"] &&
              row["vac_mobileno2"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_mobileno2.toLowerCase()
                ))) &&
          (this.state.searchData.vac_email1.length === 0 ||
            (row["vac_email1"] &&
              row["vac_email1"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_email1.toLowerCase()))) &&
          (this.state.searchData.vac_email2.length === 0 ||
            (row["vac_email2"] &&
              row["vac_email2"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_email2.toLowerCase()))) &&
          (this.state.searchData.vac_backgroundprocess === "" ||
            (row["vac_backgroundprocess"] &&
              row["vac_backgroundprocess"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_backgroundprocess.toLowerCase()
                ))) &&
          (this.state.searchData.vac_ledgereffect === "" ||
            (row["vac_ledgereffect"] &&
              row["vac_ledgereffect"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_ledgereffect.toLowerCase()
                ))) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (row["vac_remark"] &&
              row["vac_remark"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_remark.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleARDonActionClick = (row) => {
    // console.log("values", values);
    // console.log("this.state.rows",this.state.rows);

    const EditlLedgerIdSrNo = row.bint_ledgeridsrno,
      bint_srno = row.bint_acid,
      txtCompany = row.vac_comp,
      txtGSTINNO = row.vac_gstno,
      txtLegderName = row.vac_ledgername,
      txtLegderCode = row.bint_ledgercode,
      txtFirmName = row.vac_firmname,
      cmbGroupName = row.vac_groupname,
      cmbGroupHeader = row.vac_groupheader,
      cmbGstRegtrationType = row.vac_registrationtype,
      txtEligilbleITC = row.vac_eligibleitc,
      txtAddress = row.vac_address,
      cmbCity = row.vac_city,
      cmbArea = row.vac_area,
      cmbState = row.vac_state,
      txtStateCode = row.vac_statecode,
      txtPANNo = row.vac_pan,
      txtAadharNo = row.vac_adharno,
      txtOpeningAmt = row.dec_opbalance,
      cmbOpeningType = row.vac_optype,
      txtMobileno1 = row.vac_mobileno1,
      txtMobileno2 = row.vac_mobileno2,
      txtEmail1 = row.vac_email1,
      txtEmail2 = row.vac_email2,
      txtOpBalance = row.dec_opbalancecrdr,
      cmbBackgroundProcess = row.vac_backgroundprocess,
      cmbusername = row.vac_username,
      cmbLedgerEffect = row.vac_ledgereffect,
      txtAutoLedger = row.int_autoledger,
      txtRemark = row.vac_remark,
      actionName = row.actionName;
    this.DisableOnEditDelete(txtAutoLedger, cmbBackgroundProcess);
    if (actionName === "Edit") {
      // console.log("press edit button");
      if (cmbBackgroundProcess === "Delivery Responsible Person") {
        this.setState({ VisibleDeliveryPerson: true });
      } else {
        this.setState({ VisibleDeliveryPerson: false });
      }
      this.setState(
        {
          formData: {
            ...this.state.formData,
            EditlLedgerIdSrNo,
            bint_srno,
            txtCompany,
            txtGSTINNO,
            txtLegderName,
            txtLegderCode,
            txtFirmName,
            cmbGroupName,
            cmbGroupHeader,
            cmbGstRegtrationType,
            txtEligilbleITC,
            txtAddress,
            cmbCity,
            cmbArea,
            cmbState,
            txtStateCode,
            txtPANNo,
            txtAadharNo,
            txtOpeningAmt,
            cmbOpeningType,
            txtMobileno1,
            txtMobileno2,
            txtEmail1,
            txtEmail2,
            txtOpBalance,
            cmbBackgroundProcess,
            cmbusername,
            cmbLedgerEffect,
            txtAutoLedger,
            txtRemark,
          },
        },
        () => {
          // this.DisableOnEditDelete(txtAutoLedger, cmbBackgroundProcess)
          window.scrollTo(0, 0);
          document.getElementById("txtGSTINNO").focus();
        }
      );
    } else if (actionName === "Delete") {
      // console.log("press delete button");
      // console.log("bint_srno", EditlLedgerIdSrNo);
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete  : " + EditlLedgerIdSrNo + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteLedgerMaster(EditlLedgerIdSrNo);
            }}
            defaultOpenDialog={true}
            handleOnClickNo={this.ShortCut}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_ledgeridsrno"]),
      EditlLedgerIdSrNo = row.bint_ledgeridsrno;
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelAgree="Delete"
          labelDisagree="Cancel"
          alertTitle={"Do you want to Delete  : " + EditlLedgerIdSrNo + " ?"}
          alertMessage=""
          handleOnClickYes={() => {
            return this.DeleteLedgerMaster(EditlLedgerIdSrNo);
          }}
          defaultOpenDialog={true}
          handleOnClickNo={this.ShortCut}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    console.log("rtRow", rtRow);
    const row = getRowOfRT(rtRow, [
      "bint_ledgeridsrno",
      "bint_acid",
      "vac_comp",
      "vac_gstno",
      "vac_ledgername",
      "bint_ledgercode",
      "vac_firmname",
      "vac_groupname",
      "vac_groupheader",
      "vac_registrationtype",
      "vac_eligibleitc",
      "vac_address",
      "vac_city",
      "vac_area",
      "vac_state",
      "vac_statecode",
      "vac_pan",
      "vac_adharno",
      "dec_opbalancecrdr",
      "vac_optype",
      "vac_mobileno1",
      "vac_mobileno2",
      "vac_email1",
      "vac_email2",
      "dec_opbalance",
      "vac_backgroundprocess",
      "vac_username",
      "vac_ledgereffect",
      "int_autoledger",
      "vac_remark",
    ]);
    // console.log("row", row);
    const EditlLedgerIdSrNo = row.bint_ledgeridsrno,
      bint_srno = row.bint_acid,
      txtCompany = row.vac_comp,
      txtGSTINNO = row.vac_gstno,
      txtLegderName = row.vac_ledgername,
      txtLegderCode = row.bint_ledgercode,
      txtFirmName = row.vac_firmname,
      cmbGroupName = row.vac_groupname,
      cmbGroupHeader = row.vac_groupheader,
      cmbGstRegtrationType = row.vac_registrationtype,
      txtEligilbleITC = row.vac_eligibleitc,
      txtAddress = row.vac_address,
      cmbCity = row.vac_city,
      cmbArea = row.vac_area,
      cmbState = row.vac_state,
      txtStateCode = row.vac_statecode,
      txtPANNo = row.vac_pan,
      txtAadharNo = row.vac_adharno,
      txtOpeningAmt = row.dec_opbalancecrdr,
      cmbOpeningType = row.vac_optype,
      txtMobileno1 = row.vac_mobileno1,
      txtMobileno2 = row.vac_mobileno2,
      txtEmail1 = row.vac_email1,
      txtEmail2 = row.vac_email2,
      txtOpBalance = row.dec_opbalance,
      cmbBackgroundProcess = row.vac_backgroundprocess,
      cmbusername = row.vac_username ? row.vac_username : "",
      cmbLedgerEffect = row.vac_ledgereffect,
      txtAutoLedger = row.int_autoledger,
      txtRemark = row.vac_remark;

    if (cmbBackgroundProcess === "Delivery Responsible Person") {
      this.setState({ VisibleDeliveryPerson: true });
    } else {
      this.setState({ VisibleDeliveryPerson: false });
    }
    this.setState(
      {
        formData: {
          ...this.state.formData,
          EditlLedgerIdSrNo,
          bint_srno,
          txtCompany,
          txtGSTINNO,
          txtLegderName,
          txtLegderCode,
          txtFirmName,
          cmbGroupName,
          cmbGroupHeader,
          cmbGstRegtrationType,
          txtEligilbleITC,
          txtAddress,
          cmbCity,
          cmbArea,
          cmbState,
          txtStateCode,
          txtPANNo,
          txtAadharNo,
          txtOpeningAmt,
          cmbOpeningType,
          txtMobileno1,
          txtMobileno2,
          txtEmail1,
          txtEmail2,
          txtOpBalance,
          cmbBackgroundProcess,
          cmbusername,
          cmbLedgerEffect,
          txtAutoLedger,
          txtRemark,
        },
      },
      () => {
        // this.DisableOnEditDelete(txtAutoLedger, cmbBackgroundProcess)
        window.scrollTo(0, 0);
        document.getElementById("txtGSTINNO").focus();
      }
    );
  };

  //#endregion handle

  //#region function
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };
  ShortCut = () => {
    this.setState(
      {
        removeKeyboardShortCuts: setKeyboardShortcuts(
      {
        handleOnclickSave: this.SaveLedgerMaster,
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: () => {
          this.DeleteData(
            this.state.formData.EditlLedgerIdSrNo,
            this.state.formData.txtLegderName
          );
        },
        handleOnclickPluse: this.onAddClick,
      }

      // this.saveSales(true)
    )
  })
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["cmbGstRegtrationType"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateLedgerMaster = () => {
    let result = false;
    if (this.state.formData.txtLegderName.length <= 0) {
      this.props.toastErrorMsg("Enter Ledger Name", "txtLegderName");
    } else if (this.state.formData.txtLegderCode.length <= 0) {
      this.props.toastErrorMsg("Enter Ledger Code", "txtLegderCode");
    } else if (this.state.formData.cmbGroupHeader.length <= 0) {
      this.props.toastErrorMsg("Enter Group Header", "cmbGroupHeader");
    } else if (
      this.state.formData.txtGSTINNO.trim().length == 15 &&
      (this.state.formData.cmbGstRegtrationType.length == 0 ||
        this.state.formData.cmbGstRegtrationType.length == "" ||
        this.state.formData.cmbGstRegtrationType.length == undefined)
    ) {
      this.props.toastErrorMsg(
        "Enter Gst Regtration Type",
        "cmbGstRegtrationType"
      );
    } else if (
      this.state.formData.txtGSTINNO.length !== 0 &&
      this.state.formData.txtGSTINNO.trim().length < 15
    ) {
      this.props.toastErrorMsg("Enter 15 Digit GSTIN NO", "txtGSTINNO");
    } else if (
      this.state.formData.txtPANNo.length !== 0 &&
      this.state.formData.txtPANNo.trim().length < 10
    ) {
      this.props.toastErrorMsg("Enter 10 Digit PANNO", "txtPANNo");
    } else if (
      this.state.formData.txtMobileno1.length !== 0 &&
      this.state.formData.txtMobileno1.trim().length < 10
    ) {
      this.props.toastErrorMsg("Enter 10 Digit Mobile no1", "txtMobileno1");
    } else if (
      this.state.formData.txtMobileno2.length !== 0 &&
      this.state.formData.txtMobileno2.trim().length < 10
    ) {
      this.props.toastErrorMsg("Enter 10 Digit Mobile no2", "txtMobileno2");
    } else if (
      this.state.formData.txtEmail1.trim().length !== 0 &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        this.state.formData.txtEmail1
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Email 1 Address", "txtEmail1");
    } else if (
      this.state.formData.txtEmail2.trim().length !== 0 &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        this.state.formData.txtEmail2
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Email 2 Address", "txtEmail2");
    } else if (
      this.state.formData.cmbBackgroundProcess === "Delivery Responsible Person"
    ) {
      if (this.state.formData.cmbusername <= 0) {
        this.props.toastErrorMsg("Enter UserName", "cmbusername");
      } else if (
        isValidItem(
          this.state.UserNameList,
          "vac_username",
          this.state.formData.cmbusername
        ) == false
      ) {
        this.props.toastErrorMsg("Select Valid UserName", "cmbusername");
      } else {
        result = true;
      }
    } else if (this.state.formData.cmbOpeningType.length <= 0) {
      this.props.toastErrorMsg("Enter Opening Type", "cmbOpeningType");
    } else if (this.state.formData.cmbLedgerEffect.length <= 0) {
      this.props.toastErrorMsg("Select Ledger Effect", "cmbLedgerEffect");
    } else {
      result = true;
    }
    return result;
  };

  validateGstInfo = () => {
    let result = false;
    if (this.state.formData.txtGSTINNO.trim().length <= 0) {
      this.props.toastErrorMsg("Enter GSTNO", "txtGSTINNO");
    } else if (this.state.formData.txtGSTINNO.trim().length < 15) {
      this.props.toastErrorMsg("Enter 15 Digit GSTNO", "txtGSTINNO");
    } else {
      result = true;
    }
    return result;
  };

  getInfo = (nextFunctionCall = undefined) => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LedgerList",
        bint_acid: localStorage.getItem("acid"),
        year: localStorage.getItem("ACY"),
        bolLoadState: true,
        bolLoadCity: true,
        bolLoadBackgroundProcess: true,
        bolLoadUserList: true,
      };
      fetchLedgerMaster(reqData)
        .then((res) => {
          dataLoadStatus = true;
          // console.log('res.data.LedgerList', res.data.LedgerList)
          let rows = this.addActionColStatus(res.data.LedgerList),
            rowsCount = rows.length,
            txtLegderCode = "",
            maxLegderCode = "",
            GroupName = [],
            StateList = [],
            CityList = [],
            UserNameList = [],
            AreaList = [],
            BackgroundProcess = [];
          if (res.data.LedgerGroupList) {
            GroupName = res.data.LedgerGroupList;
          }
          if (res.data.StateList) {
            StateList = res.data.StateList;
          }
          if (res.data.CityList) {
            CityList = res.data.CityList;
          }
          if (res.data.UserNameList) {
            UserNameList = res.data.UserNameList;
          }
          if (res.data.AreaList) {
            AreaList = res.data.AreaList;
          }
          if (res.data.BackgroundProcess) {
            BackgroundProcess = res.data.BackgroundProcess;
          }
          if (res.data.max_bint_ledgercode) {
            txtLegderCode = res.data.max_bint_ledgercode;
            maxLegderCode = res.data.max_bint_ledgercode;
          }
          this.setState(
            {
              dataLoadStatus,
              rows,
              rowsCount,
              GroupName,
              StateList,
              CityList,
              UserNameList,
              AreaList,
              formData: {
                ...this.state.formData,
                txtLegderCode,
              },
              maxLegderCode,
              BackgroundProcess,
            },
            () => {
              if (nextFunctionCall) {
                nextFunctionCall();
              }
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtGSTINNO").focus();
  };

  clearInfo = () => {
    const EditlLedgerIdSrNo = "",
      VisibleDeliveryPerson = false,
      bint_srno = "",
      txtCompany = "",
      txtGSTINNO = "",
      txtLegderName = "",
      txtLegderCode = this.state.maxLegderCode,
      txtFirmName = "",
      cmbGroupName = "",
      cmbGroupHeader = "",
      cmbGstRegtrationType = "",
      txtEligilbleITC = "",
      txtAddress = "",
      cmbCity = "",
      cmbArea = "",
      cmbState = "Gujarat",
      txtStateCode = "24",
      txtPANNo = "",
      txtAadharNo = "",
      txtOpeningAmt = "",
      cmbOpeningType = "CR",
      txtMobileno1 = "",
      txtMobileno2 = "",
      txtEmail1 = "",
      txtEmail2 = "",
      cmbHSNCode = "",
      txtUnit = "",
      cmbBackgroundProcess = "",
      cmbusername = "",
      cmbLedgerEffect = "Cr-Cr & Dr-Dr",
      txtRemark = "";

    this.setState(
      {
        formData: {
          ...this.state.formData,
          EditlLedgerIdSrNo,
          bint_srno,
          txtCompany,
          txtGSTINNO,
          txtLegderName,
          txtLegderCode,
          txtFirmName,
          cmbGroupName,
          cmbGroupHeader,
          cmbGstRegtrationType,
          txtEligilbleITC,
          txtAddress,
          cmbCity,
          cmbArea,
          cmbState,
          txtStateCode,
          txtPANNo,
          txtAadharNo,
          txtOpeningAmt,
          cmbOpeningType,
          txtMobileno1,
          txtMobileno2,
          txtEmail1,
          txtEmail2,
          cmbHSNCode,
          txtUnit,
          cmbBackgroundProcess,
          cmbusername,
          cmbLedgerEffect,
          txtRemark,
        },
        VisibleDeliveryPerson,
      },
      () => {
        document.getElementById("txtGSTINNO").focus();
      }
    );
  };

  OnGstInfoClick = () => {
    if (this.validateGstInfo()) {
      this.props.toastErrorMsg("Development Remain..");
    }
  };

  SaveLedgerMaster = () => {
    if (this.validateLedgerMaster()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        let UserInfo = getRowData(
          this.state.UserNameList,
          "vac_username",
          this.state.formData.cmbusername
        );
        const reqData = {
          Op: "SaveLedger",
          edit_ledgeridsrno: Number(this.state.formData.EditlLedgerIdSrNo),
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          vac_company: localStorage.getItem("CompanyName"),
          vac_gstno: this.state.formData.txtGSTINNO,
          vac_ledgername: this.state.formData.txtLegderName,
          bint_ledgercode: this.state.formData.txtLegderCode,
          vac_firmname: this.state.formData.txtFirmName,
          vac_groupname: this.state.formData.cmbGroupName,
          vac_groupheader: this.state.formData.cmbGroupHeader,
          vac_registrationtype: this.state.formData.cmbGstRegtrationType,
          vac_eligibleitc: "",
          vac_address: this.state.formData.txtAddress,
          vac_city: this.state.formData.cmbCity,
          vac_area: this.state.formData.cmbArea,
          vac_state: this.state.formData.cmbState,
          vac_statecode: this.state.formData.txtStateCode,
          vac_pan: this.state.formData.txtPANNo,
          vac_adharno: this.state.formData.txtAadharNo,
          dec_opbalancecrdr: Number(this.state.formData.txtOpeningAmt),
          vac_optype: this.state.formData.cmbOpeningType,
          vac_mobileno1: this.state.formData.txtMobileno1,
          vac_mobileno2: this.state.formData.txtMobileno2,
          vac_email1: this.state.formData.txtEmail1,
          vac_email2: this.state.formData.txtEmail2,
          vac_username: this.state.formData.cmbusername,
          vac_userid: UserInfo.vac_userid ? UserInfo.vac_userid : "",
          dec_opbalance: "",
          vac_backgroundprocess: this.state.formData.cmbBackgroundProcess,
          vac_ledgereffect: this.state.formData.cmbLedgerEffect,
          int_autoledger: "",
          vac_remark: this.state.formData.txtRemark,
        };
        fetchLedgerMaster(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.getInfo(this.clearInfo);
            } else {
              this.setState({
                dataLoadStatus: true,
              });
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in SaveLedgerDetail.", error);
          });
      });
    }
  };

  DeleteData = (EditlLedgerIdSrNo, StrLedgerName) => {
    if (EditlLedgerIdSrNo > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Ledger Group : " + StrLedgerName + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteLedgerMaster(EditlLedgerIdSrNo);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteLedgerMaster = (edit_ledgeridsrno) => {
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus: false }, () => {
      const reqData = {
        Op: "DeleteLedger",
        bint_acid: localStorage.getItem("acid"),
        edit_ledgeridsrno: edit_ledgeridsrno,
      };
      fetchLedgerMaster(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState({ ARD: null }, () => {
              this.getInfo(this.clearInfo);
              // this.clearInfo();
            });
          } else {
            this.setState({ dataLoadStatus: true });
          }
        })
        .catch((error) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in LedgerGroup. " + error
          );
        });
    });
    return false;
  };

  addActionColStatus = (rows) => {
    const newRows = rows.map((row) => {
      const actionStatus = this.DisableOnEditDelete(
        row.int_autoledger,
        row.vac_backgroundprocess,
        true
      );
      return {
        ...row,
        DisableDelete: actionStatus.DisableDelete,
        DisableEdit: actionStatus.DisableEdit,
        DisableBGProcess: actionStatus.DisableBGProcess,
      };
    });
    return newRows;
  };

  DisableOnEditDelete = (
    int_autolledger,
    vac_backgroundprocess,
    returnStatus = undefined
  ) => {
    let DisableDelete = false,
      DisableEdit = false,
      DisableBGProcess = false;
    if (
      int_autolledger == 1 &&
      (vac_backgroundprocess == "Customer" ||
        vac_backgroundprocess == "Supplier" ||
        vac_backgroundprocess == "Sales" ||
        vac_backgroundprocess == "Purchase" ||
        vac_backgroundprocess == "TDS" ||
        vac_backgroundprocess == "Driver" ||
        vac_backgroundprocess == "Waybridge" ||
        vac_backgroundprocess == "Round Off")
    ) {
      DisableDelete = true;
      DisableEdit = true;
    } else {
      if (
        int_autolledger == 1 &&
        (vac_backgroundprocess == "Cash" ||
          vac_backgroundprocess == "Cheque" ||
          vac_backgroundprocess == "CGST" ||
          vac_backgroundprocess == "SGST" ||
          vac_backgroundprocess == "IGST" ||
          vac_backgroundprocess == "Reverse charge" ||
          vac_backgroundprocess == "CGST Reverse Charge" ||
          vac_backgroundprocess == "SGST Reverse Charge" ||
          vac_backgroundprocess == "IGST Reverse Charge")
      ) {
        DisableDelete = true;
        DisableEdit = false;
        DisableBGProcess = true;
      }
    }
    if (returnStatus) {
      return {
        DisableDelete,
        DisableEdit,
        DisableBGProcess,
      };
    } else {
      this.setState(
        {
          DisableDelete,
          DisableEdit,
          DisableBGProcess,
        },
        () => {
          // console.log(
          //   "this.state.DisableBGProcess",
          //   this.state.DisableBGProcess
          // );
          // console.log("this.state.DisableDelete", this.state.DisableDelete);
          // console.log("this.state.DisableEdit", this.state.DisableEdit);
        }
      );
    }
  };

  onAddClick = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<LedgerGroup
            showHeading={true}
            OpenFromLedgerMaster="Yes"

            // refreshGroupNameList={() => {
            //   this.refreshGroupNameList();
            //   this.ShortCut();
            // }}
          />
          handleOnClickNo={() => {
            this.getLedgerList();
            this.ShortCut();
          }}
          defaultOpenDialog={true}
          // handleOnClickNo={this.props.getItemList}
        />
      );
      this.setState({ ARD });
    });
  };
  getLedgerList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LedgerList",
      bint_acid: localStorage.getItem("acid"),
      bolLoadState: true,
      bolLoadCity: true,
      bolLoadBackgroundProcess: true,
      bolLoadUserList: true,
    };
    fetchLedgerMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Ledger List Loaded");
        let GroupName = res.data.LedgerGroupList;

        this.setState(
          {
            GroupName,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getLedgerList.", error);
      });
  };

  openARDGstInfo = () => {
    let vac_gstin = this.state.formData.txtGSTINNO;
    if (this.validateGstInfo()) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            alertMessage=<GstInfo vac_gstin={vac_gstin} update={this.update} />
            defaultOpenDialog={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  update = (
    legalNameOfBusiness,
    tradeName,
    address,
    gstno,
    state,
    statecode,
    taxpayertype
  ) => {
    this.setState({
      formData: {
        ...this.state.formData,
        txtLegderName: tradeName,
        txtFirmName: tradeName,
        txtAddress: address,
        txtGSTINNO: gstno,
        cmbState: state,
        txtStateCode: statecode,
        txtPANNo: gstno.substring(2, 12),
        cmbGstRegtrationType: taxpayertype,
      },
      ARD: null,
    });
  };
  //#endregion function

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    let VisibleSaveBtn = this.state.DisableEdit == true ? "none" : "block";
    let VisibleDeleteBtn = this.state.DisableDelete == true ? "none" : "block";
    let VisibleUsername =
      this.state.VisibleDeliveryPerson == true ? "block" : "none";
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {this.props.showHeading == true && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "30px", color: "#515151" }}
            >
              <b>Ledger</b>
            </label>
          </Grid>
        )}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              marginTop={3}
            >
              <Grid item>
                <label
                  htmlFor="Title"
                  style={{ fontSize: "20px", color: "#6f7689" }}
                >
                  <b>Main Details</b>
                </label>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtGSTINNO"
                  value={this.state.formData.txtGSTINNO}
                  label="GSTIN NO"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  isUpperCase={true}
                  maxLength={15}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtLegderName"
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Get GST Info."
                  onClick={this.openARDGstInfo}
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtLegderName"
                  value={this.state.formData.txtLegderName}
                  label="Ledger Name*"
                  handleOnChange={this.handleOnChange}
                  maxLength={100}
                  width={170}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtLegderCode"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtLegderCode"
                  value={this.state.formData.txtLegderCode}
                  label="Ledger Code*"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtFirmName"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtFirmName"
                  value={this.state.formData.txtFirmName}
                  label="Billing Name"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbGroupName"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbGroupName"
                  label="Group Name"
                  items={this.state.GroupName}
                  value={this.state.formData.cmbGroupName}
                  handleOnChange={this.handleOnChange}
                  width={210}
                  maxLength={100}
                  colID="vac_groupname"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbGroupHeader"
                  onAddClick={this.onAddClick}
                />
              </Grid>
              <Grid item>
                <CtCmb
                  id="cmbGroupHeader"
                  label="Group Header*"
                  items={this.state.GroupHeader}
                  value={this.state.formData.cmbGroupHeader}
                  disabled={
                    this.state.formData.cmbGroupName &&
                    this.state.formData.cmbGroupName.length > 0
                      ? true
                      : false
                  }
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={100}
                  colID="GroupHeader"
                  onKeyDown={this.props.onKeyDown}
                />
              </Grid>
              <Grid item>
                <CtCmb
                  id="cmbGstRegtrationType"
                  label="GST Registration Type"
                  items={this.state.GstRegistrationType}
                  value={this.state.formData.cmbGstRegtrationType}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={210}
                  maxLength={20}
                  colID="Type"
                />
              </Grid>
            </Grid>
            <br />
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              marginTop={0}
            >
              <Grid item>
                <label
                  htmlFor="Title"
                  style={{ fontSize: "20px", color: "#6f7689" }}
                >
                  <b>Ledger Details</b>
                </label>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item xs={10}>
                <CtMultiLineText
                  id="txtAddress"
                  label="Address"
                  value={this.state.formData.txtAddress}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={1000}
                  // onKeyDown={this.props.onKeyDown}
                  // nextCtrlID="cmbCity"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbCity"
                  label="City"
                  items={this.state.CityList}
                  value={this.state.formData.cmbCity}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={50}
                  colID="vac_city"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbArea"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbArea"
                  label="Area"
                  items={this.state.AreaList}
                  value={this.state.formData.cmbArea}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={50}
                  colID="vac_area"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbState"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbState"
                  label="State"
                  items={this.state.StateList}
                  value={this.state.formData.cmbState}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={160}
                  maxLength={50}
                  colID="vac_state"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtPANNo"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtStateCode"
                  value={this.state.formData.txtStateCode}
                  label="State Code"
                  handleOnChange={this.handleOnChange}
                  width={100}
                  disabled={true}
                  colID="vac_statecode"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtPANNo"
                  value={this.state.formData.txtPANNo}
                  label="PAN NO"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  isUpperCase={true}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtAadharNo"
                />
              </Grid>

              <Grid item>
                <CtTxt
                  id="txtAadharNo"
                  value={this.state.formData.txtAadharNo}
                  label="Aadhar No"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={12}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtOpeningAmt"
                />
              </Grid>

              <Grid item>
                <CtTxtAmt
                  id="txtOpeningAmt"
                  value={this.state.formData.txtOpeningAmt}
                  label="Opening Amount"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbOpeningType"
                />
              </Grid>
              <Grid item>
                <CtCmb
                  id="cmbOpeningType"
                  label="Opening Type*"
                  items={this.state.OpeningType}
                  value={this.state.formData.cmbOpeningType}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={160}
                  maxLength={10}
                  colID="Type"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtMobileno1"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxtNum
                  id="txtMobileno1"
                  value={this.state.formData.txtMobileno1}
                  label="Mobile No 1"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtMobileno2"
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtMobileno2"
                  value={this.state.formData.txtMobileno2}
                  label="Mobile No 2"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtEmail1"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtEmail1"
                  value={this.state.formData.txtEmail1}
                  label="Email 1"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtEmail2"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtEmail2"
                  value={this.state.formData.txtEmail2}
                  label="Email 2"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbBackgroundProcess"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmb
                  id="cmbBackgroundProcess"
                  label="Background Process"
                  items={this.state.BackgroundProcess}
                  value={this.state.formData.cmbBackgroundProcess}
                  disabled={this.state.DisableBGProcess}
                  handleOnChange={this.handleOnChange}
                  width={270}
                  maxLength={100}
                  colID="Process"
                />
              </Grid>
              <Grid item style={{ display: VisibleUsername }}>
                <CtCmbEditable
                  id="cmbusername"
                  label="User Name"
                  items={this.state.UserNameList}
                  value={this.state.formData.cmbusername}
                  // disabled={this.state.VisibleDeliveryPerson}
                  handleOnChange={this.handleOnChange}
                  width={270}
                  maxLength={100}
                  colID="vac_username"
                />
              </Grid>
              <Grid item>
                <CtCmb
                  id="cmbLedgerEffect"
                  label="Ledger Effect*"
                  items={this.state.LedgerEffect}
                  value={this.state.formData.cmbLedgerEffect}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={160}
                  maxLength={50}
                  colID="Type"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item xs={10}>
                <CtMultiLineText
                  id="txtRemark"
                  label="Remark"
                  value={this.state.formData.txtRemark}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={1000}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item style={{ display: VisibleSaveBtn }}>
                <CtBtn
                  label="Save"
                  onClick={() => {
                    this.trimFormData(() => {
                      this.SaveLedgerMaster();
                    });
                  }}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant="outlined"
                />
              </Grid>
              <Grid item style={{ display: VisibleDeleteBtn }}>
                <CtBtn
                  label="Delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.EditlLedgerIdSrNo,
                      this.state.formData.txtLegderName
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          // provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          // toolTipNewEntry='New Product Entry'
        /> */}
        <CtART
          rowsdata={this.state.rows}
          columnsdata={this.state.columnsdata}
          rowsPerPage={this.state.rowsPerPage}
          tblmaxHeight={500}
          csvFileName={csvFileName("Ledger Master")}
          // rowIconAction={[
          //   {
          //     label: "Edit",
          //     onClick: this.handleARDonActionClick_Edit,
          //     icon: "Edit",
          //     className: "secondary-button",
          //   },
          //   {
          //     label: "Delete",
          //     onClick: this.handleARDonActionClick_Delete,
          //     icon: "delete",
          //     className: "delete-button",
          //   },
          //   // this.props.userPrivilege["Entry:Proposal"] == "M"
          //   //   ? {
          //   //       label: "Delete",
          //   //       onClick: this.handleARDonActionClick_Delete,
          //   //       icon: "delete",
          //   //       className: "delete-button",
          //   //     }
          //   //   : "",
          // ]}
          rowIconAction={(row) => {
            const actions = [
              {
                label: "Edit",
                onClick: this.handleARDonActionClick_Edit,
                icon: "Edit",
                className: "secondary-button",
              },
            ];

            if (row.int_autoledger === 0) {
              actions.push({
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              });
            }
            return actions;
          }}
          showColumnFilters={false}
          actionColSize={90}
          hideColIdList={[
            "bint_ledgeridsrno",
            "vac_firmname",
            "vac_registrationtype",
            "vac_eligibleitc",
            "vac_address",
            "vac_city",
            "vac_area",
            "vac_state",
            "vac_statecode",
            "vac_pan",
            "vac_adharno",
            "vac_mobileno1",
            "vac_mobileno2",
            "vac_email1",
            "vac_email2",
            "int_autoledger",
            "dec_opbalance",
          ]}
          density={"compact"}
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(LedgerMaster)));
